// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__wG5oO","consentsList":"PatientConsents_consentsList__2fd9S","consentsListEmpty":"PatientConsents_consentsListEmpty__9d78H"};